import * as r from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Eraser.es.js";
const e = r.forwardRef((o, a) => /* @__PURE__ */ r.createElement(s, { ref: a, ...o, weights: t }));
e.displayName = "EraserIcon";
const n = e;
export {
  n as Eraser,
  e as EraserIcon
};
